import React from 'react';
import type { ISecodaEditor } from '../..';
import { Toolbar } from '../../types';
import { FloatingToolbar } from './FloatingToolbar';
import LinkEditor from './LinkEditor';

type Props = {
	editor: ISecodaEditor;
	onClickLink?: (
		href: string,
		event: MouseEvent,
		forceNewTab?: boolean
	) => void;
};

function isActive(props: Props) {
	const { editor } = props;
	const { selection } = editor.view!.state;

	try {
		const paragraph = editor.view!.domAtPos(selection.from);
		return !!paragraph.node;
	} catch (err) {
		return false;
	}
}

export default class LinkToolbar extends React.Component<Props> {
	menuRef = React.createRef<HTMLDivElement>();

	componentDidMount() {
		window.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		window.removeEventListener('mousedown', this.handleClickOutside);
	}

	// @ts-expect-error TS(7006): Parameter 'ev' implicitly has an 'any' type.
	handleClickOutside = (ev) => {
		if (
			ev.target &&
			this.menuRef.current &&
			this.menuRef.current.contains(ev.target)
		) {
			return;
		}

		this.props.editor.closeToolbars(Toolbar.Link);
	};

	handleOnCreateLink = async (title: string) => {
		const { editor } = this.props;

		editor.closeToolbars(Toolbar.Link);
		editor.view!.focus();
	};

	handleOnSelectLink = ({
		href,
		title,
	}: {
		href: string;
		title: string;
		from: number;
		to: number;
	}) => {
		const { editor } = this.props;

		editor.closeToolbars(Toolbar.Link);
		editor.view!.focus();

		const { dispatch, state } = editor.view!;
		const { from, to } = state.selection;
		if (from !== to) {
			// Selection must be collapsed
			return;
		}

		dispatch(
			editor
				.view!.state.tr.insertText(title, from, to)
				.addMark(
					from,
					to + title.length,
					state.schema.marks.link.create({ href })
				)
		);
	};

	render() {
		const { editor, ...rest } = this.props;
		const { selection } = editor.view!.state;
		const active = isActive(this.props);

		if (!active) {
			return null;
		}

		return (
			<FloatingToolbar
				ref={this.menuRef}
				view={editor.view!}
				onClose={() => editor.closeToolbars(Toolbar.Link)}
				{...rest}
			>
				{active && (
					<LinkEditor
						editor={editor}
						from={selection.from}
						to={selection.to}
						// @ts-expect-error TS(2322): Type '({ href, title, }: { href: string; title: st... Remove this comment to see the full error message
						onSelectLink={this.handleOnSelectLink}
						onRemoveLink={() => editor.closeToolbars(Toolbar.Link)}
						{...rest}
					/>
				)}
			</FloatingToolbar>
		);
	}
}
